import { AlertTriangle } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../../components/ui/alert-dialog";
import { Button } from "../../../../components/ui/button";
import { FieldGroupInstance } from "../../../../models/audit/library";

interface DeleteLibraryItemModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  instance: FieldGroupInstance | null;
  onConfirm: () => Promise<void>;
  loading?: boolean;
}

export function DeleteLibraryItemModal({
  open,
  onOpenChange,
  instance,
  onConfirm,
  loading,
}: DeleteLibraryItemModalProps) {
  if (!instance) return null;

  const handleConfirm = async () => {
    await onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center bg-red-100">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
            <AlertDialogTitle>Delete Item</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="pt-2 text-stone-600">
            Are you sure you want to delete{" "}
            <span className="font-semibold text-stone-900">
              {instance.name}
            </span>
            ? This will also remove any relationships to controls. This action
            cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="pt-4">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={loading}
            className="bg-red-600 hover:bg-red-700"
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
